export type { TransactionStatusType } from "./TransactionStatusType.js";

import { failed as _failed } from "./failed.js";
import { isFailed as _isFailed } from "./isFailed.js";
import { isPending as _isPending } from "./isPending.js";
import { isSuccess as _isSuccess } from "./isSuccess.js";
import { pending as _pending } from "./pending.js";
import { success as _success } from "./success.js";

export const pending = _pending;
export const success = _success;
export const failed = _failed;
export const isPending = _isPending;
export const isSuccess = _isSuccess;
export const isFailed = _isFailed;
